import { useEventCallback } from '@mui/material';
import { memo } from 'react';
import { DatePicker as DatePickerMaterial, DatePickerProps } from '@mui/lab';
import { DateTime } from 'luxon';

export type PmiDatePickerProps = DatePickerProps<DateTime>;

const DatePickerComponent = ({ onChange, ...props }: PmiDatePickerProps): React.ReactElement => {
  const onChangeDatePicker = useEventCallback((date: DateTime | null) => {
    if (!date) {
      onChange(date);
      return;
    }

    const dateFormatted = DateTime.fromFormat(date.toFormat('dd/MM/yyyy'), 'dd/MM/yyyy');
    onChange(dateFormatted);
  });

  return <DatePickerMaterial onChange={onChangeDatePicker} {...props} />;
};

DatePickerComponent.displayName = 'Date Picker component';

export const PmiDatePicker = memo(DatePickerComponent) as typeof DatePickerComponent;

export default PmiDatePicker;
